$(function(){

  // js-link
  //------------------------------------------------------------
  $(".js-link").on('click', function(){
    var a = $("a:eq(0)", this);
    var href = a.attr("href");
    if( a.attr("target") === "_blank" ){
      window.open(href);
    } else{
      location.href = href;
    }
    return false;
  });

  // sidr
  //------------------------------------------------------------
  $(".bt-menu").sidr({
    name: 'sp-menu',
    side: 'right',
    onOpen: function() {
      $("html").addClass("js-sidr-open");
    },
    onClose: function() {
      $("html").removeClass("js-sidr-open");
    }
  });

  if ( $("html").is(".iphone, .ipod, .ipad, .android, .windowsphone") ) {
  } else {
    $(window).on('resize', function(){
      $(".js-sidr-open .bt-menu").click();
    });
  }

  // header
  //------------------------------------------------------------
  var $box = $("#header .box-search");
  $(".texts, .btn", $box).on('tap', function(){
    $(".block", $box).toggleClass('active');

    $("input:text", $box).focus();
  });

  $(".close", $box).on('tap', function(){
    $(".block", $box).toggleClass('active');
  });

  $("#sp-header .bt-back").on('tap', function(){
    history.back();
  });

  // lang-change
  //------------------------------------------------------------
  $("#header .select-lng select, .js-lang-change").on('change', function(){
    var val = $(this).val();
    if( val ){
      location.href = val;
    }
  });

  // tab-changer
  //------------------------------------------------------------
  var tabCont = $(".tab-container");
  $("[data-cont]:eq(0)", tabCont).show();
  $("[data-href]", tabCont).on('tap', function(){

    var par = $(this).parents().filter("li");
    var cat = $(this).attr("data-href");

    $(".current", tabCont).removeClass("current");
    par.addClass("current");
    $("[data-cont]", tabCont).hide();
    $("[data-cont='"+ cat +"']", tabCont).show();
  });

  // cmn-tag-list
  //------------------------------------------------------------
  $(".cmn-tag-list .switch, .cmn-list-tag .switch").on('tap', function(){
    var that = $(this);
    var next = $(this).next();
    next.not(":animated").slideToggle(300, function(){
      that.toggleClass("active");

      if( that.hasClass("active") ){
        $("a", that).text( that.data("close") );
      } else{
        $("a", that).text( that.data("open") );
      }
    });
  });

  // tooltip
  //------------------------------------------------------------
  $(".cmn-posts-2 .icons li span").each(function(){
    var text = $(this).text();
    $(this).data("powertip", text);
  });
  $(".cmn-posts-2 .icons li span").powerTip({
    fadeInTime: 50,
    fadeOutTime: 50,
    offset: 5
  });


  // datepicker
  //------------------------------------------------------------
  $( ".datepicker" ).datepicker({

  });

  // cmn-toggle-list
  //------------------------------------------------------------
  $(".cmn-toggle-list").each(function(){
    var $t = $(this);

    $(".parent li[data-cat]", $t).each(function(){
      var cat = $(this).data("cat");
      var elm = $('<p class="show-sp switch" data-cat="'+ cat+'">'+ $(this).html() +'</p>');
      $(".sub-category div[data-cat='"+ cat +"']", $t).prepend(elm);
    });

    $("li[data-cat]").live('tap', function(){
      var cat = $(this).data("cat");
      $("[data-cat]", $t).removeClass("active");
      $("[data-cat='"+ cat +"']", $t).addClass("active");
    });

    $("p[data-cat]").live('tap', function(){
      var cat = $(this).data("cat");
      $("[data-cat='"+ cat +"']", $t).toggleClass("active");
    });
  });

  //fancybox
  //------------------------------------------------------------
  $(".fancyview").fancybox({
    padding: 8
  });

  if ( $("html").is(".iphone, .ipod, .ipad, .android, .windowsphone") ) {
    $(".fancy-movie").attr("target", "_blank");
  } else {
    $(".fancy-movie").fancybox({
      padding: 8
    });
  }

  // colorbox
  //------------------------------------------------------------
  $(".bt-close-cbox").on('tap', function(){
    $.colorbox.close();
  });


  if( $("html").is(".win, .mac") ){

    $(".sample-view").colorbox({
      iframe: true,
      maxWidth:'96%',
      maxHeight:'96%',
      innerWidth:900,
      innerHeight:600
    });

    $(".color-img").colorbox({
      scalePhotos: false,
      scrolling: true,
      maxWidth: '90%',
      maxHeight:'90%',
      innerWidth:1024,
      innerHeight: 768
    });

    $(".color-img-fit").colorbox({
      scalePhotos: true,
      scrolling: true,
      maxWidth: '90%',
      maxHeight:'90%',
      innerWidth:1024,
      innerHeight: 768
    });

    $(".color-iframe").colorbox({
      iframe: true,
      maxWidth:'96%',
      maxHeight:'96%',
      innerWidth:900,
      innerHeight:600
    });

  } else{
    $(".sample-view").attr("target", "_blank");
    $(".color-img").attr("target", "_blank");
    $(".color-iframe").attr("target", "_blank");
  }

  // mailto
  //------------------------------------------------------------
  $("[data-mail]").each(function(){
    var address = $(this).data("mail");
    var domain = $(this).data("domain");
    $(this).text(address + "@" + domain);
    $(this).attr("href", "mailto:" + address + "@" + domain);
  });

  // pagetop
  //------------------------------------------------------------
  var btn = $("#footer .bt-pagetop");

  // トップページで詳細な分岐あり
  if( $("body").is("#home") && $("html").attr("data-mode") != "sp" ){
    // btn.addClass("active");
    // btn.addClass("reverse");

    setInterval(function(){

      btn.toggleClass("animate");
    }, 500);
  }

  $(window).on('scroll load', function(){
    var scTop = $(window).scrollTop();

    if(scTop > 100){
      btn.addClass("active");
      btn.removeClass("reverse");
    } else{
      if( $("body").is("#home") && $("html").attr("data-mode") != "sp" ){
        btn.addClass("reverse");
      } else{
        btn.removeClass("active");
      }
    }
  });

  btn.click(function(){
    if( $(this).hasClass("reverse") ){
      var pos = $("#cont-pc").offset().top;
      $('html,body').animate({ scrollTop: pos }, 600);

    } else{
      $('html,body').animate({ scrollTop: 0 }, 600);
    }
  });

  // map 有効化
  //------------------------------------------------------------
  if ( $("html").is(".iphone, .ipod, .ipad, .android, .windowsphone") ) {
    $(".map-wrap").on('tap', function(){
      if(confirm("マップを有効にしますか？")){
        $("#gmap", this).addClass("active");
        $(this).unbind();
      }
    });
  }
});



// WEBPACK FOOTER //
// ./_src/js/action/action.js